import { useMemo, useReducer, useState } from "react";
import FusePageSimple from "@fuse/core/FusePageSimple/FusePageSimple";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import DashboardHeader from "./DashBoardHeader";
import DashboardBody from "./DashboardBody";

const Root = styled(FusePageSimple)(({ theme }) => ({
  "& .FusePageSimple-header": {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
  },
  "& .FusePageSimple-toolbar": {},
  "& .FusePageSimple-content": {},
  "& .FusePageSimple-sidebarHeader": {},
  "& .FusePageSimple-sidebarContent": {},
}));

export default function DashboardPage() {
  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
      <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
        <Root
          header={<DashboardHeader />}
          content={<DashboardBody />}
          scroll="content"
        />
      </Box>
    </Box>
  );
}
